export default __webpack_public_path__ + "static/media/main_section14.4c95a061.jpg";